import { ProductBubbleSx } from '@/components/blocks/FreeGiftV2/styles/freeGift';
import { generateImageUrl } from '@/components/blocks/FreeGiftV2/utils';
import { Img } from '@/components/blocks/MaterialImage';
import { Badge } from '@mui/material';

interface ProductWithBubbleProps {
	isPurchase?: boolean;
	quantity: number;
	partNumber: string;
}

export const ProductWithBubble = ({
	isPurchase = false,
	quantity,
	partNumber,
}: ProductWithBubbleProps) =>
	quantity > 1 ? (
		<Badge
			badgeContent={quantity}
			color="success"
			overlap="circular"
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'right',
			}}
			sx={isPurchase ? ProductBubbleSx.badgePurchase : ProductBubbleSx.badge}
			key={partNumber}
		>
			<Img sx={ProductBubbleSx.image} src={generateImageUrl(partNumber, true)} alt={partNumber} />
		</Badge>
	) : (
		<Img sx={ProductBubbleSx.image} src={generateImageUrl(partNumber, true)} alt={partNumber} />
	);
